import React from 'react';
import PropTypes from 'prop-types';
import SidePaneDetailsComponent from 'apex-web/lib/components/common/SidePaneDetailsComponent/SidePaneDetailsComponent';

var _createClass = (function() {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ('value' in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function(Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
})();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    );
  }
  return call && (typeof call === 'object' || typeof call === 'function')
    ? call
    : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError(
      'Super expression must either be null or a function, not ' +
        typeof superClass
    );
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass)
    Object.setPrototypeOf
      ? Object.setPrototypeOf(subClass, superClass)
      : (subClass.__proto__ = superClass);
}

var FiatDepositDetailsComponent = (function(_React$Component) {
  _inherits(FiatDepositDetailsComponent, _React$Component);

  function FiatDepositDetailsComponent() {
    _classCallCheck(this, FiatDepositDetailsComponent);

    return _possibleConstructorReturn(
      this,
      (
        FiatDepositDetailsComponent.__proto__ ||
        Object.getPrototypeOf(FiatDepositDetailsComponent)
      ).apply(this, arguments)
    );
  }

  _createClass(FiatDepositDetailsComponent, [
    {
      key: 'render',
      value: function render() {
        var _props$info = this.props.info,
          info = _props$info === undefined ? {} : _props$info;

        var showCustomText = info && info.text && info.text.length > 0;
        var showLink = info && info.link;

        var defaultInfo = [
          this.context.t(
            'Step 1: Create the deposit ticket. Sender’s bank details should match with the wallet account. Third party and/or anonymous payments cannot be accepted.'
          ),
          this.context.t(
            'Step 2: Please deposit the stated amount to the provided bank account details.'
          ),
          this.context.t(
            'Note - The information from the deposit ticket will be emailed to you.'
          ),
          this.context.t(
            'The deposit of these funds might take up to 7 business days, and it’s subject to operator review.'
          )
        ];
        return React.createElement(SidePaneDetailsComponent, {
          title: this.context.t('Instructions'),
          info: showCustomText ? info.text : defaultInfo,
          link: showLink ? { text: info.link } : { text: '' },
          classModifiers: 'deposit'
        });
      }
    }
  ]);

  return FiatDepositDetailsComponent;
})(React.Component);

FiatDepositDetailsComponent.propTypes = {
  info: PropTypes.object
};

FiatDepositDetailsComponent.contextTypes = {
  t: PropTypes.func.isRequired
};

export default FiatDepositDetailsComponent;
